/**
 * @typedef {import("./state").DataState} DataState
 */

export default {
  /**
   *
   * @param {DataState} state
   * @returns
   */
  stage(state) {
    return state.stage;
  },
  /**
   *
   * @param {DataState} state
   * @returns
   */

  file(state) {
    return state.file;
  },
  /**
   *
   * @param {DataState} state
   * @returns
   */
  record(state) {
    return state.record;
  },
  /**
   *
   * @param {DataState} state
   * @returns
   */
  editting(state) {
    return state.editting;
  },
  /**
   *
   * @param {DataState} state
   * @returns
   */
  normalizationResponse(state) {
    return state.normalizationResponse;
  },
  /**
   *
   * @param {DataState} state
   * @returns
   */
  duplicateCheckResponse(state) {
    return state.duplicateCheckResponse;
  },
  /**
   *
   * @param {DataState} state
   * @returns
   */
  dbDuplicateCheckResponse(state) {
    return state.DBduplicateCheckResponse;
  },
  /**
   * @param {DataState} state
   */
  normalizationState(state) {
    return state.isNormalized;
  },
  /**
   * @param {DataState} state
   */
  duplicateCheckState(state) {
    return state.hasPassedDuplicatesCheck;
  },
  /**
   * @param {DataState} state
   */
  dbDuplicateCheckState(state) {
    return state.hasPassedDBDuplicatesCheck;
  },
  /**
   *
   * @param {DataState} state
   * @returns
   */
  records(state) {
    return state.records;
  },

  /**
   *
   * @param {DataState} state
   * @returns
   */
  uploads(state) {
    return state.uploads;
  },
  /**
   *
   * @param {DataState} state
   * @returns {Array<String}
   */
  headers(state) {
    if (!state.record) return [];
    return Object.keys(state.record.data[0]).filter((x) => "$id" !== x);
  },
  getDataType(state) {
    return state.dataType;
  },
};
